module.exports = __webpack_public_path__ + "img/Practical Fixer.f9d1bc13.svg";